module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slidemenu"
    }
  }, [(_vm.isVisible) ? _c('div', {
    staticClass: "bg-accent",
    attrs: {
      "id": "menu"
    }
  }, [_c('div', {
    staticClass: "menu_container"
  }, [_c('div', {
    staticClass: "col-7"
  }, [_c('h2', {
    staticClass: "h2 medium"
  }, [_c('span', {
    staticClass: "upcase"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.configurator == 'k1_wall' ? 'k1' : _vm.configurator) + "\n\t\t\t\t")]), _vm._v("\n\t\t\t\tConfigurator\n\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    directives: [{
      name: "nlbr",
      rawName: "v-nlbr",
      value: (_vm.$t((_vm.configurator + "_instructions"))),
      expression: "$t(`${configurator}_instructions`)"
    }],
    staticClass: "h3 light"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-4 upcase"
  }, [_c('span', {
    staticClass: "h5 regular c-dark"
  }, [_vm._v("ON KRIPTONITE.COM")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "c-light h5 light",
    attrs: {
      "target": "_blank",
      "href": "http://kriptonite.com"
    }
  }, [_c('span', {
    staticClass: "medium"
  }, [_vm._v("> KRIPTONITE")]), _vm._v(" WEBSITE")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "c-light h5 light",
    attrs: {
      "target": "_blank",
      "href": ("http://www.kriptonite.com/" + _vm.LOCALE + "/products/k1")
    }
  }, [_c('span', {
    staticClass: "medium"
  }, [_vm._v("> K1")]), _vm._v(" " + _vm._s(_vm.$t('productpage')))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "c-light h5 light",
    attrs: {
      "target": "_blank",
      "href": ("http://www.kriptonite.com/" + _vm.LOCALE + "/products/k2")
    }
  }, [_c('span', {
    staticClass: "medium"
  }, [_vm._v("> K2")]), _vm._v(" " + _vm._s(_vm.$t('productpage')))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "c-light h5 light",
    attrs: {
      "target": "_blank",
      "href": ("http://www.kriptonite.com/" + _vm.LOCALE + "/products/krossing")
    }
  }, [_c('span', {
    staticClass: "medium"
  }, [_vm._v("> KROSSING")]), _vm._v(" " + _vm._s(_vm.$t('productpage')))])])]), _vm._v(" "), _c('div', {
    staticClass: "menu_footer c-dark h7 regular"
  }, [_c('div', {
    staticClass: "col-5 t-left"
  }, [_vm._v("\n\t\t\tPowered by "), _c('a', {
    staticClass: "medium c-dark",
    attrs: {
      "target": "_blank",
      "href": "http://kriptonite.com"
    }
  }, [_vm._v("KRIPTONITE")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 t-right"
  }, [_vm._v("\n\t\t\tDesign & Coding "), _c('a', {
    staticClass: "c-dark",
    attrs: {
      "target": "_blank",
      "href": "http://display.xxx"
    }
  }, [_vm._v("display.xxx")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5784578"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/partials/Menu.vue
// module id = 661
// module chunks = 0